import unitedStates from '../../../constants/unitedStates';
import {ESTABLISHMENT_STATE_RULES_ENUMERATION as establishmentEnumeration}  from '../../../constants/EstablishmentStatusEnumeration';
const rulesEnumeration = {
  REQUIRED_TO_COLLECT_FOR_UNDER_20: "1",
  REQUIRED_TO_COLLECT_GOVERNMENT_UNDER_20: "2",
  NOT_REQUIRED_TO_USE_APP: "5",
  NOT_REQUIRED_TO_COLLECT_STATE_LOCAL_GOVERNMENT: "6"
};

export default function checkStatePlanRules(establishment, rules, specialMessage, field) {

  //check to see if establishment is in a state that doesn't use the federal
  //ITA application
  if (!rules) {
    return [];
  }
  const excludedStatesData = window.getExcludedStatesData();
  let managed_by_state_plan = false;
  if (excludedStatesData['fully_excluded_states'].includes(establishment.state.toUpperCase())) {
    managed_by_state_plan = true;
  }
  else if (excludedStatesData['partially_excluded_states'].includes(establishment.state.toUpperCase()) &&
    (establishment.establishmentType == establishmentEnumeration.STATE_GOVERNMENT || establishment.establishmentType == establishmentEnumeration.LOCAL_GOVERNMENT)) {
    managed_by_state_plan = true;
  }

  if (managed_by_state_plan) {
    return [];
  }

  let messages = [];
  let setDefaultUnder20Message = true;
  const defaultUnder20Message = " does not require establishments with less than 20 employees to report their data to OSHA.";

  if (rules.indexOf(rulesEnumeration.NOT_REQUIRED_TO_USE_APP) >= 0 && field === 'state') {
    messages = [];
    messages.push({message: specialMessage || "You are not required to file for an establishment in this state"});
    // if state is not required to file an establishment, they don't need the default 20 and under message
    setDefaultUnder20Message = false;
  }
  //check to see if establishment is required to collect for 20 and under
  //check to see if they selected under 20 people
  else if (rules.indexOf(rulesEnumeration.REQUIRED_TO_COLLECT_FOR_UNDER_20) >= 0){
    if(establishment.size == establishmentEnumeration.UNDER_20 && establishment.state) {
      //do not set the message
      setDefaultUnder20Message = false;
    }
  }
  //check to see if they chose type state/local government, are selecting under 20, and are required to file
  //for this type of establishment
  else if (rules.indexOf(rulesEnumeration.REQUIRED_TO_COLLECT_GOVERNMENT_UNDER_20) >= 0){
    if(establishment.size == establishmentEnumeration.UNDER_20
    && establishment.establishmentType != establishmentEnumeration.NON_GOVERNMENT
    && establishment.state) {
      //state/local gov is required to file, so hide the message
      setDefaultUnder20Message = false;
    }
  }

  else if (rules.indexOf(rulesEnumeration.NOT_REQUIRED_TO_COLLECT_STATE_LOCAL_GOVERNMENT) >=0){
    if(establishment.establishmentType == establishmentEnumeration.STATE_GOVERNMENT
    || establishment.establishmentType == establishmentEnumeration.LOCAL_GOVERNMENT
    && establishment.state) {
      //if state/local govt, set the new message and hide under 20 message.
      messages.push({message: specialMessage || "State and Local Governments in this state aren't required to file using ITA."});
      setDefaultUnder20Message = false;
    }
  }
  //if we must set the default under 20 message, and the establishment size is under 20, then...
  //drumroll...........
  // Hide default message.
  // Don't send any state plan related messages at all per latest change
  // requested on 2024/1/17.
  setDefaultUnder20Message = false;
  messages = [];
  if(setDefaultUnder20Message && establishment.state
    && establishment.size == establishmentEnumeration.UNDER_20){
    const stateMessage = {
      state: unitedStates[establishment.state],
      message: defaultUnder20Message
    };
    messages.push(stateMessage);
  }
  return messages;
}



/** WEBPACK FOOTER **
 ** ./src/components/establishment/establishmentManagement/StatePlanRules.js
 **/